module.exports = __webpack_public_path__ + "img/beijingtu (5).e08df4ba.png";